<script setup lang="ts">
import { onBeforeMount, ref, useAttrs } from "vue";

import { TcLoader } from "../UI";

import { hasValue, isObject, keysOf } from "@/Utils/Objects";

export interface TcSuspenseProps {
  asyncCall?: () => Promise<unknown>;
  isLoading?: boolean;
  isCenterLoader?: boolean;
}

const isLoaded = ref<boolean>(false);

const props = withDefaults(defineProps<TcSuspenseProps>(), { isLoading: false, isCenterLoader: true });
const attrs: Record<string, unknown> = useAttrs();

onBeforeMount(async () => {
  if (hasValue(props.asyncCall)) {
    isLoaded.value = false;

    await props.asyncCall();
  }

  isLoaded.value = true;
});
</script>

<template>
  <template v-if="!hasValue(attrs) || !isObject(attrs) || keysOf(attrs).length === 0">
    <slot name="header" />

    <slot v-if="isLoaded && !props.isLoading" />

    <slot name="loader" v-else>
      <TcLoader :center="props.isCenterLoader" />
    </slot>
  </template>

  <div v-else v-bind="attrs">
    <slot name="header" />

    <slot v-if="isLoaded && !props.isLoading" />

    <slot name="loader" v-else>
      <TcLoader :center="props.isCenterLoader" />
    </slot>
  </div>
</template>
